// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KPNYt","title":"Footer_title__pHIlT","text":"Footer_text__8Anse"};